import {DivIcon} from "leaflet";

const ICON_SVG = '<svg width=\'100%\' height=\'100%\' xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' preserveAspectRatio=\'xMidYMid\'>\n			<circle cx=\'50\' cy=\'50\' r=\'40\' fill=\'white\' stroke=\'rgba(0,0,0,0.7)\' stroke-width=\'10\'></circle>\n		</svg>'

export const buildMouseOverWaypointIcon = () => {
    return new DivIcon({
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        className: '',
        html: `<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'>
			<circle cx='50' cy='50' r='40' fill='white' stroke='rgba(0,0,0,0.7)' stroke-width='10'></circle>
		</svg>`
    });
}

const buildIcon = ({
                       showMarkerPointNumber,
                       pointIndex,
                   }: {
    showMarkerPointNumber?: boolean,
    pointIndex?: number,
} = {}) => {
    if (!showMarkerPointNumber || (!pointIndex && pointIndex !== 0)) {
        return ICON_SVG
    }
    return `<div style="position: relative">${ICON_SVG}<div style="font-size:10px;position: absolute;left: 50%;top:50%;transform: translate(-50%,-50%);color: black }">${pointIndex + 1}</div></div>`

}

export const buildDraggableWaypointIcon = ({
                                               showMarkerPointNumber,
                                               pointIndex,
                                               firstPointOnTheIndex,
                                               lastPointOnTheIndex,
                                           }: {
    showMarkerPointNumber?: boolean,
    pointIndex?: number,
    lastPointOnTheIndex?: boolean,
    firstPointOnTheIndex?: boolean,
} = {}) => {
    return new DivIcon({
        iconSize: [20, 20],
        iconAnchor: [10, 10],
        className: '',
        html: buildIcon({
            showMarkerPointNumber,
            pointIndex,

        })
    })
}